import React, { useState } from 'react';
import { faChevronRight, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useImage } from '../../../context/ImageContext';

const ProductDropdown = ({ selectedProduct, setIsProductModalOpen, setSelectedProduct, setProductPrompt }) => {
    const { activeTab } = useImage();
    const handleReset = (e) => {
        e.stopPropagation();
        setSelectedProduct({
            "src": "https://img.icons8.com/?size=100&id=6RfZ-eZQz0ee&format=png&color=737373",
            "name": "No Product Selected",
            "alt": "No Product Selected"
        });
        setProductPrompt("");
       
    };

    return (
        <div
            className="flex items-center justify-between p-1 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer group relative overflow-hidden bg-white"
            onClick={() => setIsProductModalOpen(true)}
        >
            <div className="absolute inset-0 bg-gradient-to-r from-[#4B3BFF] to-[#7B6BFF] opacity-0 group-hover:opacity-5 transition-all duration-300"></div>
            <div className="flex items-center space-x-3 relative">
                <img
                    alt={selectedProduct.name}
                    className="w-10 h-10 rounded-lg group-hover:scale-110 transition-transform duration-300 object-cover"
                    height="40"
                    src={selectedProduct.src}
                    width="40"
                />
                <span className="text-sm text-gray-800 group-hover:text-[#4B3BFF] transition-colors duration-300">{selectedProduct.name}</span>
            </div>
            <div className="flex items-center relative z-10">
                {selectedProduct.name !== "No Product Selected" && (
                    <button
                        onClick={handleReset}
                        className="mr-1 text-gray-400 hover:text-red-500 transition-all duration-300 relative z-20"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                    </button>
                )}
                <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 group-hover:text-[#4B3BFF] group-hover:translate-x-1 transition-all duration-300 relative z-10 pr-2" />
            </div>
        </div>
    );
};

export default ProductDropdown;
